var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIllustrationEmptyTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "illustration-empty-table_svg__a",
    cx: 45,
    cy: 45,
    r: 45
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "illustration-empty-table_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#illustration-empty-table_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EDF1F7",
    opacity: 0.665,
    xlinkHref: "#illustration-empty-table_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration-empty-table_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.276 69.702h11.128c.328 0 .596-.206.596-.456v-.208c0-.251-.268-.456-.596-.456H78.276c-.328 0-.596.205-.596.456v.208c0 .25.268.456.596.456M78.276 83.142h11.128c.328 0 .596-.205.596-.456v-.208c0-.251-.268-.456-.596-.456H78.276c-.328 0-.596.205-.596.456v.208c0 .25.268.456.596.456",
    fill: "#F1F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.04 54.022s-.157 5.6-6.16 5.6-6.16-5.6-6.16-5.6h12.32",
    fill: "#EAEAE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.04 50.102s-.157 5.6-6.16 5.6-6.16-5.6-6.16-5.6h12.32",
    fill: "#EAEAE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.753 35.85l4.488 5.41a3.934 3.934 0 003.32 1.418l19.933-1.482c3.096-.23 5.792 2.117 6.02 5.242l2.71 37.148c.229 3.124-2.097 5.844-5.194 6.074l-55.267 4.106c-3.097.23-5.792-2.116-6.02-5.241L8.25 40.67c-.16-2.195 1.474-4.105 3.65-4.267l26.532-1.972a3.934 3.934 0 013.32 1.418",
    fill: "#3769A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.344 93.782c-2.917 0-5.383-2.274-5.601-5.257L8.25 40.671a4.048 4.048 0 01-.011-.294c-.002-2.069 1.582-3.819 3.66-3.973l26.533-1.972a3.936 3.936 0 013.32 1.417l4.488 5.411c.221.268.474.502.75.698l-25.1 4.264c-1.44.245-2.42 1.633-2.177 3.086l.108.645-5.228.388h-.01l-.822.062c-1.456.108-2.56 1.399-2.452 2.867l2.636 36.117c.102 1.403 1.273 2.481 2.646 2.481.065 0 .13-.002.196-.007l.824-.061.007-.001 1.873-.14 55.353-4.112c1.39-.103 2.46-1.284 2.46-2.67 0-.065-.003-.13-.008-.197l-.412-5.645.995-.169.344 4.72a5.688 5.688 0 01-1.995 4.765 5.572 5.572 0 01-3.199 1.309l-16.963 1.26-38.304 2.846c-.14.01-.28.016-.419.016",
    fill: "#8F9BB3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.152 39.562L13.005 41.14c-.43.036-.81-.33-.841-.812l-.002-.025c-.032-.482.295-.906.726-.941l19.147-1.577c.43-.035.81.33.841.812l.002.025c.032.482-.295.906-.726.941M29.349 43.298L13.009 44.5a.791.791 0 01-.845-.728l-.002-.023a.79.79 0 01.73-.844l16.34-1.201a.791.791 0 01.844.728l.002.023a.79.79 0 01-.73.843",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.197 87.768l-58.62 4.326a2.69 2.69 0 01-2.869-2.48l-2.66-36.223a2.692 2.692 0 012.475-2.876l58.62-4.326a2.69 2.69 0 012.869 2.481l2.66 36.223a2.692 2.692 0 01-2.475 2.875",
    fill: "#D4D5CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.208 87.825l-57.534 4.27c-1.463.108-2.75-1.01-2.857-2.485l-2.65-36.271c-.108-1.476 1.002-2.772 2.465-2.88l57.534-4.27c1.464-.109 2.75 1.01 2.857 2.485l2.65 36.27c.108 1.476-1.002 2.772-2.465 2.88",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F0EC",
    d: "M19.44 91.542l12.32-.879-11.153-35.521-1.167 36.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66 77.245l-57.58 9.78c-1.443.245-2.824-.746-3.066-2.203l-5.977-35.81c-.243-1.457.74-2.85 2.183-3.094l57.58-9.779c1.444-.245 2.824.746 3.067 2.202l5.976 35.81c.243 1.457-.74 2.85-2.183 3.094",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.234 87.062a2.688 2.688 0 01-2.637-2.246l-6-35.91c-.244-1.46.742-2.856 2.192-3.101l56.975-9.666a2.66 2.66 0 01.443-.037c1.279 0 2.417.935 2.636 2.245l6 35.91c.025.148.037.296.037.441.002 1.29-.926 2.44-2.229 2.66l-56.975 9.666a2.66 2.66 0 01-.442.038m50.569-39.997c-.062 0-.125.005-.189.016l-53.128 9.012a1.153 1.153 0 00-.936 1.325l.263 1.573a1.148 1.148 0 001.315.943l53.128-9.013c.619-.105 1.04-.701.935-1.325l-.262-1.572a1.148 1.148 0 00-1.126-.96m-1.258-7.34c-.065 0-.13.005-.195.017l-53.054 9a1.19 1.19 0 00-.967 1.368l.298 1.785a1.185 1.185 0 001.358.974l53.054-9a1.19 1.19 0 00.967-1.368l-.299-1.786a1.185 1.185 0 00-1.162-.99",
    fill: "#EDF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.95 52.902a1.174 1.174 0 01-1.157-.97l-.297-1.747a1.167 1.167 0 01.962-1.339l52.798-8.808a1.174 1.174 0 011.351.953l.297 1.747a1.167 1.167 0 01-.962 1.34l-52.798 8.808c-.065.01-.13.016-.194.016M26.999 60.182a1.144 1.144 0 01-1.121-.959l-.262-1.572a1.152 1.152 0 01.932-1.324l52.906-9.01a1.144 1.144 0 011.309.942l.261 1.574a1.151 1.151 0 01-.932 1.324l-52.905 9.009c-.063.01-.126.016-.188.016",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.686 88.842L23.48 93.36l-5.72.423c3.159-.233 5.532-2.989 5.3-6.155l-1.849-25.15a3.793 3.793 0 013.5-4.064l59.37-4.38a3.79 3.79 0 014.055 3.506l1.848 25.15a5.743 5.743 0 01-5.298 6.153",
    fill: "#C5CEE0",
    fillRule: "nonzero"
  })))));
}

export default SvgIllustrationEmptyTable;